module.exports = __webpack_public_path__ + "static/img/logo-example-14.428bd1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-example-14.svg
// module id = /zCZ
// module chunks = 0